<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="verfify_tooltip_name" :name="verfify_tooltip_name" :description="verify_tooltip_description" :editable="editable"></tool-tip>

    <div class="row">
      <div class="col-sm-12">
        <el-table
          :data="lineItems"
          :summary-method="summary"
          show-summary
          :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
        >
          <!-- <el-table-column v-if="!isPartnerAccount && !isReceived" :min-width="100" align="left" label="Actions">
            <div slot-scope="props" class="table-actions">
              <el-tooltip
                content="Edit Line Item"
                :open-delay="300"
                effect="light"
                placement="top"
              >
                <base-button
                  :disabled="isReadOnly"
                  class="btn btn-icon btn-fab btn-default btn-sm btn-link"
                  @click.native="viewItem(props.row.lineItemId)"
                >
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
              </el-tooltip>
            </div>
          </el-table-column> -->

          <el-table-column :min-width="105" prop="itemNumber" label="Item No" />
          <el-table-column
            :min-width="155"
            prop="fundCitationName"
            label="Fund Citation"
          />
          <el-table-column
            :min-width="155"
            prop="stockClassName"
            label="Class of Supply"
          />
          <el-table-column
            :min-width="150"
            prop="stockSubClassName"
            label="Sub Class"
          />
          <el-table-column
            :min-width="205"
            prop="stockDescription"
            label="Stock No & Description"
          />
          <el-table-column
            :min-width="155"
            prop="unitMeasure"
            label="Unit of Measure"
          />
          <el-table-column
            :min-width="210"
            prop="requestedQuantity"
            label="Request Qty"
            :formatter="formatMoney"
          />
          <el-table-column
            :min-width="210"
            prop="receivedQuantity"
            label="Received Qty"
          >
            <editable-cell
              :show-input="editMode"
              slot-scope="{ row }"
              v-model="row.receivedQuantity"
              type="number"
              v-on:input="markChanged(row.lineItemId);filterNumber($event)"
            >
              <span slot="content">{{
                row.receivedQuantity != null
                  ? formatNumber(row.receivedQuantity)
                  : ""
              }}</span>
            </editable-cell>
          </el-table-column>
          <el-table-column
            :min-width="210"
            prop="unitPrice"
            label="Unit Price"
            :formatter="formatMoney"
          />
          <el-table-column
            :min-width="210"
            prop="partnerItemTotal"
            label="Partner Total"
            :formatter="formatMoney"
          />
          <el-table-column
            :min-width="210"
            prop="usItemTotal"
            label="US Total($)"
            :formatter="formatMoney"
          />
          <el-table-column
            :min-width="210"
            prop="usItemBalance"
            label="US Balance Due($)"
            :formatter="formatMoney"
          />
        </el-table>
        <div
          style="margin-top: 20px; float: right;"
          v-if="!isReadOnly && !isPartnerAccount && !isReceived"
        >
          <base-button
            :disabled="isReadOnly"
            v-show="editMode"
            type="danger"
            class="alert_footer_button mr-4 btn_extra_small btn_info"
            @click.native="cancelEditMode"
          >
            Cancel
          </base-button>
          <base-button
            :disabled="isReadOnly"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="handleEdit()"
          >
            {{ editMode ? "Save" : "Edit" }}
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BaseSwitch, BaseButton, EditableCell } from "@/components";
import Util from "@/util/util";
import  toolTip  from "../../../Tooltip";


export default {
  name: "verify-receipt-quantity",
  props: ["isReadOnly"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    EditableCell,
    toolTip
  },
  async mounted() {
   await this.getAllTooltips()
   this.loadToolTips()
 },

  data() {
    return {
      openEndedLsssTypeId: 5,
      editMode: false,
      editing: null,
      renderKey: 0,
      changedItems: [],
      verify_tooltip_description: '',
      verfify_tooltip_name: ''
    };
  },
  computed: {
    ...mapGetters({
      lineItems: "lineItemReceipt/lineItems",
      lineItemErrors: "lineItemReceipt/lineItemErrors",
      preOrder: "preOrderDetail/preOrder",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      order: "orders/order",
      isReceived: "orderMetadata/isReceived",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isOpenEndedLsssType() {
      return this.preOrder.lssTypeId == this.openEndedLsssTypeId;
    },
  },
  methods: {
    ...mapActions({
      getLineItems: "lineItemReceipt/getLineItems",
      getLineItemReceiptStatus: "lineItemReceipt/getLineItemReceiptStatus",
      saveLineItems: "lineItemReceipt/saveLineItems",
      getPreOrder: "preOrderDetail/getPreOrder",
      getOrderByStatus: "orders/getOrderByStatus",
      getAllTooltips: "tooltip/getToolTips",
      updateAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/updateAllDisbursingInfoByOrderId",
    }),
    loaded() {
      this.getPreOrder(this.$route.params.id);
      this.getLineItems(this.$route.params.id);
    },
    loadToolTips(){
    const verifyToolTip = this.toolTips.find(e => e.name === "VerifyReceiptModule")
    if(verifyToolTip.status){
    
      this.verify_tooltip_description = verifyToolTip.description ? verifyToolTip.description :  null
      this.verfify_tooltip_name = verifyToolTip.name ? verifyToolTip.name :  null
    }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    showVerifyReceiptQuantityErrors() {
      if (this.lineItemErrors.length > 0) {
        this.lineItemErrors.forEach((error) => this.$toast.error(error));
        this.modals.classic = false;
      } else {
        this.getLineItems(this.$route.params.id);
        this.modals.classic = false;
      }
    },
    formatReceivedQuantity(row, column, cellValue) {
      return Util.numberWithCommas(cellValue);
    },
   filterNumber(evt) {
      // only allow number
      // to prevent extra chars, use event.keyCode === <charCode> || <repeat>
        evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      }

      // Prevent more than one decimal point
if (charCode === 46 && evt.target.value.includes(".")) {
  evt.preventDefault();
  return;
}

// Limit to 10 digits after the decimal point
if (evt.target.value.includes(".")) {
  var decimalPart = evt.target.value.split(".")[1];
  if (decimalPart && decimalPart.length >= 10) {
    evt.preventDefault();
    return;
  }
}
        return true; 
    },
    formatMoney(row, column, cellValue) {
      return Util.inMoneyFormatWithoutDollarSign(cellValue);
    },
    formatNumber(cellValue) {
      let val = new Intl.NumberFormat("en-US", {
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 10,
      }).format(cellValue);
      return val;
    },
    async handleEdit() {
      if (this.editMode) {
        await this.saveItemQuantities();
      } else {
        this.editMode = true;
      }
    },
    markChanged(id) {
      if (this.changedItems.includes(id)) return;

      this.changedItems.push(id);
    },
    async saveItemQuantities() {
      let updateStatus = false;
      // Loop through each of the line items
      // Fetch LineItem for each

      let bases = this.lineItems.filter((item) => {
          return this.changedItems.includes(item.lineItemId);
        }
      );
      let items = bases.map((itm) => {
          return {
            lineItemId: itm.lineItemId,
            orderId: itm.orderId,
            receivedQuantity: itm.receivedQuantity,
            unitPrice: itm.unitPrice,
            requestedQuantity: itm.requestedQuantity,
            partnerItemTotal: itm.partnerItemTotal,
            usItemTotal: itm.usItemTotal,
            usItemBalance: itm.usItemBalance,
            fundCitationId: itm.fundCitationId
          };
      });

      if(bases !== null && bases.length !== 0) {
        await this.saveLineItems(items).then(async (res) => {
          updateStatus = true;
          this.changedItems = [];
                  
          // deep copy, since after refresh, the items array will be gone.
          let fundCitationIds = Object.assign([], items.map(i => i.fundCitationId));
          let orderId = (items.length > 0) ? items[0]['orderId'] : -1;
      
          await this.getLineItems(this.$route.params.id);
          await this.getLineItemReceiptStatus(this.$route.params.id);
          await this.refreshOrder();

          if(fundCitationIds.length > 0 && orderId !== -1) {
            await this.updateAllDisbursingInfoByOrderId({
              orderId: orderId,
              fundcitationIds: fundCitationIds.join(',')
            });
          }
        });
      } else {
        this.$toast.error("Cannot save. No changes to Line Items have been made.");
      }

      //this.$toast.success("Line Item(s) Saved");
      this.editMode = false;
    },

    async refreshOrder() {
      let ctx = this;

      await this.getOrderByStatus({
        orderStatus: ctx.orderMetadata.orderStatus,
        id: ctx.$route.params.id,
      });
    },
    cancelEditMode() {
      this.editMode = false;
      this.getLineItems(this.$route.params.id);
    },
    validOpenEndedReceivedQuantity(receivedQuantity) {
      return (
        this.isOpenEndedLsssType &&
        (receivedQuantity == null || receivedQuantity > 0.01)
      );
    },
    validNonOpenEndedReceivedQuantity(receivedQuantity) {
      return (
        !this.isOpenEndedLsssType &&
        receivedQuantity != null &&
        receivedQuantity > 0.01
      );
    },
    receivedQuantityIsValid(receivedQuantity) {
      return (
        this.validOpenEndedReceivedQuantity(receivedQuantity) ||
        this.validNonOpenEndedReceivedQuantity(receivedQuantity)
      );
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    generateTotal(values) {
      if (!values.every((value) => isNaN(value))) {
        return values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      } else {
        return null;
      }
    },
    summary(param) {
      const { columns, data } = param;
      const sums = [];
      const totalColumns = ["usItemTotal"];
      const quantityColumns = [
        "requestedQuantity",
        "receivedQuantity",
        "unitPrice",
        "partnerItemTotal",
        "usItemBalance",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totals";
          return;
        }

        if (quantityColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? Util.inMoneyFormatWithoutDollarSign(total)
            : "0.00";
          if (column.property == "requestedQuantity") {
            sums[index] = total
              ? Util.inMoneyFormatWithoutDollarSign(total)
              : "0.00";
          }
          if (column.property == "receivedQuantity") {
            sums[index] = total
              ? Util.inMoneyFormatWithoutDollarSign(total)
              : "";
          }
          if (column.property == "usItemBalance") {
            sums[index] = total
              ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
              : "$ 0.00";
          }
        } else if (totalColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
            : "$ 0.00";
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
  },
};
</script>